import qs from "qs";
import authAxios, { authHeader } from "../../data";

const fetchAll = async (request: any) => {
  const response = await authAxios.get(
    `/api/Accesses/contracts/${request.contractNumber}/history`,
    {
      params: request,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
    },
  );

  return response.data;
};

const fetchCount = async (request: any) => {
  const response = await authAxios.get(
    `/api/Accesses/contracts/${request.contractNumber}/history/count`,
    {
      params: request,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
    },
  );

  return response.data;
};

const fetchYears = async (accountNumber: number) => {
  const result = await authAxios.get(
    `/api/Accesses/contracts/${accountNumber}/years`,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

const ExtUserPaymentHistoryService = {
  fetchAll,
  fetchCount,
  fetchYears,
};

export default ExtUserPaymentHistoryService;
